// The command a user runs on the runner machine to bring an offline runner back.
export const RUNNER_START_COMMAND = 'factiii-runner start';

// Disconnecting revokes the runner and kills its running jobs, so the warning
// has to name the job count. Shared by the settings list and the board runner
// picker so the two can't drift on what is a destructive action.
export const runnerDisconnectMessage = (jobCount: number): string =>
  jobCount
    ? `This runner has ${jobCount} job${jobCount === 1 ? '' : 's'} running. Disconnecting will stop ${jobCount === 1 ? 'it' : 'them'}, delete the job container${jobCount === 1 ? '' : 's'}, and revoke the runner. You'll need to re-pair from the runner CLI to reconnect.`
    : "This runner will be revoked immediately. You'll need to re-pair from the runner CLI to reconnect it.";
